@if (supportInfo != undefined && supportInfo!=null){
<section class="support-section">
    <div class="support-content">
        <div class="support-text">
            <h1 class="support-title">{{ supportInfo.title }}</h1>
            <ul class="support-list">
                @for(item of supportInfo.items; track item.order) {
                <li class="publish-point">
                    <span class="icon-check" aria-hidden="true"></span>
                    <span class="point-text">{{item.text }}</span>
                </li>
                }
            </ul>
        </div>
        <div class="support-image">
            <img src="/assets/images/support.webp" width="488" height="304"  alt="Support" />
        </div>
    </div>
</section>
}